export enum UserRole {
  SuperAdmin = 'AASuperAdmin',
  CustomerService = 'AACustomerService',
  Legal = 'AALegal',
  ReadOnly = 'AAReadOnly',
  Iopex = 'AAIopex',
  DirectProfileDelete = 'AADirectProfileDelete'
}

export enum AppFunction {
  OktaProfile = 'Okta Profile',
  DeleteOktaProfile = 'Delete Okta Profile',
  FindUserInDPL = 'Find User in DPL Table',
  ClearUserFromDPL = 'Clear User from DPL Table',
  PasswordReset = 'Password Reset',
  SetTemporaryPassword = 'Set Temporary Password',
  ActivationEmail = 'Activation Email',
  GenerateLink = 'Generate Link',
  AttributeManagement = 'Attribute Management',
  PIIReport = 'PII Report'
}

export const functionRoleMap: Record<AppFunction, UserRole[]> = {
  [AppFunction.OktaProfile]: [
    UserRole.SuperAdmin,
    UserRole.CustomerService,
    UserRole.ReadOnly,
    UserRole.Iopex
  ],
  [AppFunction.DeleteOktaProfile]: [
    UserRole.SuperAdmin,
    UserRole.CustomerService,
    UserRole.Iopex
  ],
  [AppFunction.FindUserInDPL]: [
    UserRole.SuperAdmin,
    UserRole.CustomerService,
    UserRole.Legal,
    UserRole.ReadOnly,
    UserRole.Iopex
  ],
  [AppFunction.ClearUserFromDPL]: [
    UserRole.SuperAdmin,
    UserRole.Legal,
    UserRole.Iopex
  ],
  [AppFunction.PasswordReset]: [UserRole.SuperAdmin],
  [AppFunction.SetTemporaryPassword]: [UserRole.SuperAdmin],
  [AppFunction.ActivationEmail]: [UserRole.SuperAdmin],
  [AppFunction.GenerateLink]: [UserRole.SuperAdmin],
  [AppFunction.AttributeManagement]: [UserRole.SuperAdmin],
  [AppFunction.PIIReport]: [UserRole.SuperAdmin, UserRole.CustomerService]
}
